A single item in a `CandidateProfile`'s workflow process history.
